import React from "react";
import {
    Box,
    Typography,
    Grid,
    Container
} from "@mui/material";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ImageSlider from "./ImageSlider";
import { useMediaQueries } from "../../usecontext/UseProvider";

const AboutProduct = ({ productData }) => {
    const { isSmallScreen, isMediumScreen, isLargeScreen } = useMediaQueries();
    const { wpNumber } = useMediaQueries();

    const details = [
        { label: "Category", value: productData?.createdBy?.name },
        {
            label: "Tags",
            value: productData?.tags?.join(", ") || "",
        },
        {
            label: "Size",
            value: `Length: ${productData?.length},  Width: ${productData?.width},    Height: ${productData?.height}`,
        },
        {
            label: "Material",
            value: productData?.material,
        },
    ];

    const handleWhatsAppOrder = () => {
        const productName = productData?.name || "Product";
        const productDescription = productData?.description || "Product Description";
        const productCategory = productData?.createdBy?.name || "Not specified";
        const productTags = productData?.tags ? productData.tags.join(", ") : "No tags";
        const productSize = `Length: ${productData?.length || "N/A"}, Width: ${productData?.width || "N/A"}, Height: ${productData?.height || "N/A"}`;
        const productMaterial = productData?.material || "Not specified";

        // Get current product page URL
        const productPageUrl = window.location.href; // Do NOT encode it

        const message = `Hello! I am interested in ordering the following product:\n\n
    *Name:* ${productName}
    *Description:* ${productDescription}
    *Category:* ${productCategory}
    *Tags:* ${productTags}
    *Size:* ${productSize}
    *Material:* ${productMaterial}
    
    Product Page:
    ${productPageUrl}
    
    Please provide more details.`;

        // WhatsApp URL
        const whatsappUrl = `https://wa.me/${wpNumber}?text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, "_blank");
    };

    return (
        <Box >
            <Container sx={{ py: { lg: 8, xs: 3 } }} >
                <Grid container spacing={6} alignItems="center">
                    {/* Left Section - Image */}
                    <Grid item xs={12} md={6} data-aos="fade-right" textAlign={"center"}>
                        <ImageSlider images={productData?.images || []} />
                    </Grid>

                    {/* Right Section - Content */}
                    <Grid item xs={12} md={6} data-aos="fade-left">
                        <Typography
                            variant={isSmallScreen ? 'h5' : 'h4'}
                            sx={{ fontWeight: "bold", marginBottom: 3 }}
                        >
                            {productData?.name}
                        </Typography>
                        <Typography
                            variant={"body2"}
                            sx={{
                                fontSize: { lg: '20px', md: '18px', xs: '16px' },
                            }}
                        >
                            {productData?.description}
                        </Typography>

                        <Box sx={{ lineHeight: 1.6, mt: { lg: 4, xs: 2 } }}>
                            <Grid container spacing={3}>
                                {/* Column for labels */}
                                {details?.map((detail, index) => (
                                    <React.Fragment key={`${index}-${detail.label}`}>
                                        <Grid item xs={3}>
                                            <Typography
                                                variant={isSmallScreen ? "body1" : "h6"}
                                                fontWeight="bold"
                                            >
                                                {detail.label}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={7}>
                                            <Typography
                                                variant={isSmallScreen ? "body2" : "body1"}
                                            >
                                                {detail.value}
                                            </Typography>
                                        </Grid>
                                    </React.Fragment>
                                ))}
                            </Grid>
                        </Box>
                        <Box
                            sx={{
                                backgroundColor: '#C6F9C6',
                                display: 'flex',
                                borderRadius: '80px',
                                width: 'fit-content',
                                gap: 2,
                                alignItems: 'center',
                                px: 1.5,
                                py: 1,
                                mt: { lg: 4, xs: 3 },
                                cursor: 'pointer'
                            }}
                            onClick={handleWhatsAppOrder}
                        >
                            <WhatsAppIcon
                                sx={{
                                    backgroundColor: '#35CC35',
                                    color: '#fff',
                                    height: '30px',
                                    width: '30px',
                                    borderRadius: '50%',
                                    p: 0.5
                                }}
                            />
                            <Typography variant="body1">
                                Order on WhatsApp
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default AboutProduct;